import * as lodash from 'lodash';

export const BPMN_RENDERER = {
  bpmnRenderer: {
    defaultFillColor: '#ffffff',
    defaultStrokeColor: 'rgba(0,0,0, 0.15)',
  }
};

export const CHROME_FONT_SIZE = 16;

export const TEXT_RENDERER = {
  textRenderer: {
    defaultStyle: {
      fontFamily: 'CentraleSans Book',
      fontSize: `${CHROME_FONT_SIZE}px`,
      fontWeight: '500',
      fontStyle: 'normal',
      fontStretch: 'normal',
      width: '158px',
      height: '110px',
      lineHeight: '1.5',
      padding: { top: 12, left: 12, right: 12, bottom: 12},
      letterSpacing: '0px',
      fill: 'rgba(0, 0, 0, 0.8)',
      align: 'left-top',
      node_padding: {
        neighborhood_entry: { right: 44},
        neighborhood_head: { left: 44},
        treatment: { bottom: -20}
      }
    }
  }
};

export const IE11_FONT_SIZE = 15;
export const MAX_TREATMENT_NODE_LABEL_STRING_NUM = 2;
export const SHIFT_COEFF = 0.3;

const TEXT_RENDERER_IE11_PROPERTIES = {
  textRenderer: {
    defaultStyle: {
      fontSize: `${IE11_FONT_SIZE}px`,
    }
  }
};

export const TEXT_RENDERER_FOR_IE11 = lodash.merge({ }, TEXT_RENDERER, TEXT_RENDERER_IE11_PROPERTIES);
